import { v4 as uuidv4 } from 'uuid'

import { AD_FORMAT } from '../../../../../../../constants/ads'

import {
  AD_DESCRIPTION,
  AD_HEADLINE,
  AD_PREVIEW_CAROUSEL_INDEX_KEY,
  AD_TEXT,
  CALL_TO_ACTION,
  CAROUSEL_ITEMS,
  CAROUSEL_ITEMS_LENGTH,
  CLICK_THROUGH_LINK,
  DESCRIPTION_BLANK,
  DESCRIPTION_ENTER,
  DESCRIPTION_OPTION,
  DESCRIPTIONS_LIST,
  FORMAT_CAROUSEL,
  FORMAT_OPTION,
  FORMAT_SINGLE,
  HEADLINE_BLANK,
  HEADLINE_ENTER,
  HEADLINE_OPTION,
  HEADLINES_LIST,
  initialCarouselItem,
  IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY,
  IS_ITEM_FORM_OPENED,
  PRIMARY_TEXT_LIST,
  TEXT_BLANK,
  TEXT_ENTER,
  TEXT_OPTION
} from '../../../../fields'
import {
  IMAGE_HASH,
  FILE_ID,
  FILE_NAME,
  FILE_URL,
  MEDIA_FILE_OPTION,
  MEDIA_FILE_UPLOAD,
  MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../../../../../ReusableFormFields/AdFileUpload/fields'
import { formatSingleItemWithStoryToBE } from '../../../../AdFacebookCreate/AdFacebookCreateForm/formatters/formatAdCreativeToBE/formatSingleImageOrVideoToBE/formatSingleItemWithStoryToBE'
import { formatChildAttachments } from '../../../../AdFacebookCreate/AdFacebookCreateForm/formatters/formatAdCreativeToBE/formatCarouselItemsToBE/formatChildAttachments'
import { formatSingleItemFeedToBE } from '../../../../AdFacebookCreate/AdFacebookCreateForm/formatters/formatAdCreativeToBE/formatSingleImageOrVideoToBE/formatSingleItemToBE/formatSingleItemFeedToBE'

export function getInitialValuesByFormat(adValues, adFormat) {
  switch (adFormat) {
    case AD_FORMAT.carousel:
      return getCarouselInitialValues(adValues)
    case AD_FORMAT.single:
    default:
      return getSingleInitialValues(adValues)
  }
}

export function getCarouselInitialValues(adValues) {
  return {
    [FORMAT_OPTION]: AD_FORMAT.carousel,
    [CAROUSEL_ITEMS]: adValues[CAROUSEL_ITEMS],
    [IS_ITEM_FORM_OPENED]: true,
    [MEDIA_FILE_OPTION]: MEDIA_FILE_UPLOAD,

    // primary text
    [PRIMARY_TEXT_LIST]: adValues[AD_TEXT] ? [{ text: adValues[AD_TEXT] }] : [{ text: '' }],
    [AD_PREVIEW_CAROUSEL_INDEX_KEY]: adValues[AD_PREVIEW_CAROUSEL_INDEX_KEY]
  }
}

export function getSingleInitialValues(adValues) {
  const singleMediaItem = {
    // ad text
    [PRIMARY_TEXT_LIST]: adValues[PRIMARY_TEXT_LIST]?.map(item => ({ ...item, id: uuidv4() })),
    [TEXT_OPTION]: !!adValues[AD_TEXT] ? TEXT_ENTER : TEXT_BLANK,
    // headline
    [HEADLINE_OPTION]: !!adValues[AD_HEADLINE] ? HEADLINE_ENTER : HEADLINE_BLANK,
    [HEADLINES_LIST]: adValues[HEADLINES_LIST]?.map(item => ({ ...item, id: uuidv4() })),
    // // description
    [DESCRIPTION_OPTION]: !!adValues[AD_DESCRIPTION] ? DESCRIPTION_ENTER : DESCRIPTION_BLANK,
    [DESCRIPTIONS_LIST]: adValues[DESCRIPTIONS_LIST]?.map(item => ({ ...item, id: uuidv4() })),
    // open existed library image or video
    [MEDIA_FILE_OPTION]: MEDIA_FILE_UPLOAD,
    ...adValues
  }

  return {
    ...singleMediaItem,
    // isCustom
    [FORMAT_OPTION]: AD_FORMAT.single,
    [IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY]: adValues[IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY]
  }
}

export function transformCarouselToSingle(carouselItems) {
  const carouselItemValues = carouselItems[0]

  // change format option to single
  return {
    ...carouselItemValues,
    singleMediaItem: {
      ...carouselItemValues
    },
    [FORMAT_OPTION]: FORMAT_SINGLE
  }
}

export function transformSingleToCarousel(modifiedAdValues) {
  const carouselItem = {
    [DESCRIPTION_OPTION]: modifiedAdValues.singleMediaItem[DESCRIPTION_OPTION],
    [AD_DESCRIPTION]: modifiedAdValues.singleMediaItem[AD_DESCRIPTION],
    [DESCRIPTIONS_LIST]: modifiedAdValues.singleMediaItem[DESCRIPTIONS_LIST],
    [HEADLINE_OPTION]: modifiedAdValues.singleMediaItem[HEADLINE_OPTION],
    [AD_HEADLINE]: modifiedAdValues.singleMediaItem[AD_HEADLINE],
    [HEADLINES_LIST]: modifiedAdValues.singleMediaItem[HEADLINES_LIST],
    [CALL_TO_ACTION]: modifiedAdValues.singleMediaItem[CALL_TO_ACTION],
    [CLICK_THROUGH_LINK]: modifiedAdValues.singleMediaItem[CLICK_THROUGH_LINK],
    [MEDIA_TYPE]: modifiedAdValues.singleMediaItem[MEDIA_TYPE],
    [MEDIA_FILE_OPTION]: modifiedAdValues.singleMediaItem[MEDIA_FILE_OPTION],
    [IMAGE_HASH]: modifiedAdValues.singleMediaItem[IMAGE_HASH],
    [FILE_ID]: modifiedAdValues.singleMediaItem[FILE_ID],
    [VIDEO_PICTURE]: modifiedAdValues.singleMediaItem[VIDEO_PICTURE],
    [FILE_URL]: modifiedAdValues.singleMediaItem[FILE_URL],
    [FILE_NAME]: modifiedAdValues.singleMediaItem[FILE_NAME]
  }

  // add new initial item to carousel items array
  // CLICK_THROUGH_LINK, CALL_TO_ACTION from existed item must be added to new item
  const newCarouselItem = {
    ...initialCarouselItem,
    [CLICK_THROUGH_LINK]: modifiedAdValues.singleMediaItem[CLICK_THROUGH_LINK],
    [CALL_TO_ACTION]: modifiedAdValues.singleMediaItem[CALL_TO_ACTION]
  }

  // change format option to carousel, combine existed media item with newly created
  return {
    [FORMAT_OPTION]: FORMAT_CAROUSEL,
    [CAROUSEL_ITEMS]: [carouselItem, newCarouselItem],
    [CAROUSEL_ITEMS_LENGTH]: 2,
    [AD_PREVIEW_CAROUSEL_INDEX_KEY]: modifiedAdValues[AD_PREVIEW_CAROUSEL_INDEX_KEY],
    // pre Open edit form
    [IS_ITEM_FORM_OPENED]: true,
    // is custom
    [IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY]: modifiedAdValues.singleMediaItem[IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY]
  }
}

export function getCreative({ values, originalAd, adFormat, adAccountId }) {
  const facebookPageId = originalAd.creative.object_story_spec?.page_id

  const multiShareEndCard = originalAd?.creative?.object_story_spec?.multi_share_end_card
  const multiShareOptimized = originalAd?.creative?.object_story_spec?.multi_share_optimized

  let adText = values.singleMediaItem?.[PRIMARY_TEXT_LIST]?.[0].text
  let adHeadline = values.singleMediaItem?.[HEADLINES_LIST]?.[0].text
  let adDescription = values.singleMediaItem?.[DESCRIPTIONS_LIST]?.[0].text

  const singleValues = {
    ...values,
    ...values.singleMediaItem,
    [AD_TEXT]: adText,
    [AD_HEADLINE]: adHeadline,
    [AD_DESCRIPTION]: adDescription
  }

  switch (adFormat) {
    case AD_FORMAT.carousel:
      const carouselItems = values[CAROUSEL_ITEMS].map(item => {
        // For edit form if OPTION === BLANK send empty string
        let adHeadline = item[HEADLINES_LIST]?.[0].text
        let adDescription = item[DESCRIPTIONS_LIST]?.[0].text
        adHeadline = item[HEADLINE_OPTION] === HEADLINE_ENTER ? adHeadline : ''
        adDescription = item[DESCRIPTION_OPTION] === DESCRIPTION_ENTER ? adDescription : ''

        return {
          ...item,
          [DESCRIPTIONS_LIST]: [{ text: adDescription }],
          [HEADLINES_LIST]: [{ text: adHeadline }],
          // For edit form all options should be: ENTER to allow to send empty strings
          [DESCRIPTION_OPTION]: DESCRIPTION_ENTER,
          [HEADLINE_OPTION]: HEADLINE_ENTER
        }
      })

      return {
        object_story_spec: {
          link_data: {
            // FB requires this field for a carousel ad, so the link is taken from first Carousel item
            child_attachments: formatChildAttachments(carouselItems),
            link: values[CAROUSEL_ITEMS][0][CLICK_THROUGH_LINK],
            ...(originalAd.creative.object_story_spec?.caption && {
              caption: originalAd.creative.object_story_spec?.caption
            }),
            message: values[PRIMARY_TEXT_LIST]?.[0].text,

            // multi_share_end_card and multi_share_optimized are set if ad is created as carousel,
            // if ad was created as single, and we switch it to carousel - set both as false
            multi_share_end_card: multiShareEndCard || false,
            multi_share_optimized: multiShareOptimized || false
          },
          page_id: facebookPageId
        }
      }
    case AD_FORMAT.single:
      return {
        object_story_spec: {
          ...formatSingleItemFeedToBE(singleValues),
          page_id: facebookPageId
        }
      }
    case AD_FORMAT.singleCustom:
    default:
      return formatSingleItemWithStoryToBE({ values: singleValues, selectedAdAccountId: adAccountId, originalAd })
  }
}
